import * as moment from "moment/moment";

export class Income {
  constructor() {
    this.id = null;
    this.income_for = "Shop";
    this.date = moment().format("YYYY-MM-DD");
    this.category_id = null;
    this.warehouse_id = null;
    this.shop_id = null;
    this.amount = null;
    this.remark = null;
  }
}
